import { Box } from "@mui/material";
import React from "react";
import useTheme from "../../../../../../../common/hooks/useTheme";
import { Theme } from "../../../../../../../providers/ThemeProvider";

type Props = {
  label: string;
  /** "status" is the white pill (Swapped); "content" the outlined chip (equipment, sub-type). */
  kind?: "status" | "content";
  /** Smaller text and padding, for tight spots such as the 80px exercise photo. */
  small?: boolean;
};

/** The same pill the nutrition cards use (`PlanTag`), for the workout plan's chips. */
const WorkoutTag = ({ label, kind = "content", small = false }: Props) => {
  const theme: Theme = useTheme();
  return <Box sx={styles.pill(theme, kind, small)}>{label}</Box>;
};

export default WorkoutTag;

const styles = {
  pill: (theme: Theme, kind: "status" | "content", small: boolean) => ({
    display: "inline-flex",
    alignItems: "center",
    padding: small ? "1px 6px" : "2px 8px",
    borderRadius: "12px",
    border: `1px solid ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
    backgroundColor:
      kind === "status" ? theme.colors_ds.NEUTRAL_BG_MAIN : "transparent",
    color:
      kind === "status"
        ? theme.colors_ds.NEUTRAL_TEXT_STRONG
        : theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
    fontFamily: "var(--font-Medium)",
    fontSize: small ? "10px" : "12px",
    lineHeight: small ? "14px" : "16px",
    whiteSpace: "nowrap" as "nowrap",
  }),
};
